/**
 * Scholarships
 */
$(document).on("ready", function () {

  var scholTimeout = false;
  if ($(".scholarship").length) {
    $(document).on("click", ".save", function () {
      var $svbtn = $(this);
      if (scholTimeout || $svbtn.hasClass('work-based-learning')) {
        return false;
      }
      addWaiting();
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action:'fw_fakeSaveScholarship',
          ScholarshipID: $(this).attr("id"),
          scholarshipType: $(this).data('type'),
        }, // serializes the form's elements.
        dataType: "json",
        success: function (data) {
          $svbtn.closest(".scholarship").find(".error").remove();
          removeWaiting();
          if (data[0] === "success") {
            $svbtn.removeClass("save").removeClass("primary").addClass("remove").addClass("secondary").text("REMOVE");
            console.log("success");
          } else if (data.errors.length > 0) {
            $svbtn.closest(".scholarship").find(".error").remove();
            for (var i = 0; i < data.errors.length; i++) {
              $svbtn.closest(".scholarship").append('<p class="error">' + data.errors[i] + "</p>");
            }
          } else {
            $svbtn.closest(".scholarship").append('<p class="error">' + data + "</p>");
          }
          scholTimeout = false;
          $(".save, .remove").removeClass("disabled");
        },
        error: function () {},
      });
      scholTimeout = true;
      $(".save").addClass("disabled");
    });
    $(document).on("click", ".remove, td.remove span", function () {
      var $svbtn = $(this);
      addWaiting();
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: 'fw_fakeSaveScholarship',
          ScholarshipID: $(this).attr("id"),
          scholarshipType: $(this).data('type'),
          remove: true,
        }, // serializes the form's elements.
        dataType: "json",
        success: function (data) {
          removeWaiting();
          if (data[0] === "success") {
            if ($svbtn.hasClass("mycareer")) {
              window.location.reload();
            } else {
              $svbtn.removeClass("remove").removeClass("secondary").addClass("save").addClass("primary").text("SAVE");
            }
            //console.log('remove');
          } else if (data.errors.length > 0) {
            for (var i = 0; i < data.errors.length; i++) {
              $cur.children(".errors").append('<p class="error">' + data.errors[i] + "</p>");
            }
          } else {
            $cur.children(".errors").append('<p class="error">' + data + "</p>");
          }
        },
        error: function () {},
      });
    });
    $("#scholarshipStatus, #scholarshipAward").on("change", function () {
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: 'fw_fakeUpdateFavScholarship',
          ScholarshipID: $(this).attr("data-id"),
          which: $(this).attr("data-which"),
          val: $(this).val(),
        }, // serializes the form's elements.
        dataType: "json",
        success: function (data) {
          if (data[0] === "success") {
            window.location.reload();
          } else if (data.errors.length > 0) {
            for (var i = 0; i < data.errors.length; i++) {
              //$cur.children('.errors').append('<p class="error">'+data.errors[i]+'</p>');
            }
          } else {
            //$cur.children('.errors').append('<p class="error">'+data+'</p>');
          }
        },
        error: function () {},
      });
    });
  }
});
